import { APP_CONSTANTS } from "../../constants";
import { api } from "../api";

const centerApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getCenters: builder.query<[], { page: number, search?: string }>({
            query: ({ page = 1, search }) => {
                    const take = APP_CONSTANTS.TABLES.centers.limit;
                    const skip = (page - 1) * take;
                    const include = {
                        city: {
                          select: {
                            id: true, 
                            name:true,                           
                            province: {
                              select: { id: true, 
                                 name:true, 
                                 region: {
                                    select: { id: true, 
                                       name:true, 
      
                                     },
      
                                  },
                               },

                            },
                          },
                        },
                       
                      };
            let queryString = `/center?skip=${skip}&take=${take}`;
            if (search) queryString += `&search=${search}`;
            queryString += `&include=${JSON.stringify(include)}`;
            return queryString;
            }
        }),
    }),

});
export const {
    useGetCentersQuery,
}= centerApi;
export default centerApi;
